export enum SalePatternIssueBusinessDayMode {
    AccordingTo = 'AccordingTo',
    Before = 'Before',
    After = 'After'
}
